// MAIN FAQ -- START

$('.accordion .accordion-head').click(function () {
  $(this).closest('.accordion').siblings().find('.accordion-body').slideUp(300);
  $(this).closest('.accordion').siblings().find('.accordion-body').removeClass('active');
  if(jQuery('.faq-wrapper , .ingitem.ingcontent').find('.accordion-wrapper').length>0){
    jQuery('.faq-wrapper , .ingitem.ingcontent').find('.accordion-wrapper').find('.accordion').removeClass('active');
  }
  $(this).next('.accordion-body').slideToggle(300);
  $(this).next('.accordion-body').toggleClass('active');
  $(this).closest('.accordion').siblings().find('.accordion-head').find('.plus-icon').removeClass('minus');
  $(this).closest('.accordion').siblings().find('.accordion-head').removeClass('active');
  $(this).toggleClass('active');
  if($(this).hasClass('active')){
     $(this).parent().addClass('active');
  }else{
    $(this).parent().removeClass('active');
  }
  $(this).find('.plus-icon').toggleClass('minus');
});

$(document).ready(function() {
  // First accordion open
  var firstAccordion = $('.accordion').first();
  firstAccordion.find('.accordion-head').addClass('active');
  firstAccordion.find('.accordion-body').addClass('active').slideDown(0); // 0 duration so it's instantly open
  firstAccordion.addClass('active');
  firstAccordion.find('.plus-icon').addClass('minus');
});

// MAIN FAQ -- END

// PRODUCT COMAPRIOSN -- START

document.addEventListener("DOMContentLoaded", function () {
  const firstAccordionItemHeader = document.querySelector(
    ".pc_faq_header"
  );
  const firstAccordionItemBody = firstAccordionItemHeader.nextElementSibling;

  // Open the first accordion item by default
  firstAccordionItemHeader.classList.add("active");
  firstAccordionItemBody.style.maxHeight =
    firstAccordionItemBody.scrollHeight + "px";

  const accordionItemHeaders = document.querySelectorAll(
    ".pc_faq_header"
  );

  accordionItemHeaders.forEach((accordionItemHeader) => {
    accordionItemHeader.addEventListener("click", (event) => {
      const currentlyActiveAccordionItemHeader = document.querySelector(
        ".pc_faq_header.active"
      );
      if (
        currentlyActiveAccordionItemHeader &&
        currentlyActiveAccordionItemHeader !== accordionItemHeader
      ) {
        currentlyActiveAccordionItemHeader.classList.toggle("active");
        currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
      }
      accordionItemHeader.classList.toggle("active");
      const accordionItemBody = accordionItemHeader.nextElementSibling;
      if (accordionItemHeader.classList.contains("active")) {
        accordionItemBody.style.maxHeight =
          accordionItemBody.scrollHeight + "px";
      } else {
        accordionItemBody.style.maxHeight = 0;
      }
    });
  });
});

// PRODUCT COMAPRIOSN -- END

// Featured Product -- start


$('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  infinite: false,
  fade: true,
  asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  dots: false,
  infinite: false,
  centerMode: false,
  focusOnSelect: true
});
	

$(document).ready(function() {
  $(".collapsible-panel > .collapsible-heading").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".collapsible-content")
        .slideUp(200);
      $(".collapsible-panel > .collapsible-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".collapsible-panel > .collapsible-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".collapsible-panel > .collapsible-heading").removeClass("active");
      $(this).addClass("active");
      $(".collapsible-content").slideUp(200);
      $(this)
        .siblings(".collapsible-content")
        .slideDown(200);
    }
  });
});

// Featured Product -- end